var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5775",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8 30.65L33.2 19.25L31.1 17.2L21.95 26.35L16.9 21.3L14.7 23.5L21.8 30.65ZM24 43.95C19.3333 42.7833 15.5 40.075 12.5 35.825C9.5 31.575 8 26.9166 8 21.85V9.94995L24 3.94995L40 9.94995V21.85C40 26.9166 38.5 31.575 35.5 35.825C32.5 40.075 28.6667 42.7833 24 43.95ZM24 40.85C27.8333 39.5833 30.9583 37.1916 33.375 33.675C35.7917 30.1583 37 26.2166 37 21.85V12.05L24 7.14995L11 12.05V21.85C11 26.2166 12.2083 30.1583 14.625 33.675C17.0417 37.1916 20.1667 39.5833 24 40.85Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUser);
export default __webpack_public_path__ + "static/media/verified_user.e45702d4ae5e998b151bca2bbdcbb134.svg";
export { ForwardRef as ReactComponent };